export const platform = (name) => {
  let arr = JSON.parse(localStorage.getItem("platform")) || [];

  if (arr.includes(name)) {
    arr = arr.filter((item) => item !== name);
  } else {
    arr.push(name);
  }

  localStorage.setItem("platform", JSON.stringify(arr));
};

export const appfeature = (name, index) => {
  let x = JSON.parse(localStorage.getItem("appFeatures")) || {
    size: [],
    ui: [],
    account: [],
    user: [],
    date: [],
    social: [],
    billing: [],
    admin: [],
    integration: [],
    security: [],
    specific: [],
  };

  const properties = [
    "size",
    "ui",
    "account",
    "user",
    "date",
    "social",
    "billing",
    "admin",
    "integration",
    "security",
    "specific",
  ];

  const propertyName = properties[index];

  if (index === 0 || index === 1) {
    x[propertyName] = x[propertyName].includes(name) ? [] : [name];
  } else {
    const existingIndex = x[propertyName].indexOf(name);

    if (existingIndex !== -1) {
      x[propertyName] = x[propertyName].filter((item) => item !== name);
    } else {
      x[propertyName].push(name);
    }
  }

  localStorage.setItem("appFeatures", JSON.stringify(x));
};
